module.exports = __webpack_public_path__ + "img/bluesky3100_34.df535cd8.jpg";